import React from 'react';

import { Box } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import { Typography } from '@mui/material';

import { getTypeOfUser, TypeOfUser } from '@pharmaplan/common';

import strings from '../../localization';
import CustomButton from '../common/CustomButton';
import { Constants } from '../../helpers/Constants';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import { resetDialog } from '../../reducers/dialogReducer';
import { ReactComponent as WelcomeToPharmaGapIcon } from '../../assets/svg/pharmagapWelcome.svg';

import { useAppSelector } from '../../hooks/useAppSelector';

import styles from './styles';

const { pharmacy } = TypeOfUser;

const WelcomeToPharmaGap = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const userType = useAppSelector(getTypeOfUser);
  const isPharmacy = userType === pharmacy;

  const close = () => {
    dispatch(resetDialog());
  };

  const navigateToBilling = () => {
    navigate(Constants.paths.pharmacistBilling);
    close();
  };

  const navigateToPharmacyBilling = () => {
    navigate(Constants.paths.pharmacyBilling);
    close();
  };

  const config = () => {
    if (isPharmacy) {
      return {
        primary: navigateToPharmacyBilling,
        title: strings.welcomeToPharmaGap,
        description: strings.pleaseSelectAndAddCardDetails,
      };
    }

    return {
      primary: navigateToBilling,
      title: strings.thankYouForJoiningPharmaGap,
      description: strings.welcomeToPharmaGapSubMessage,
    };
  };

  const { primary, title, description } = config();

  return (
    <Box sx={styles.container}>
      <Box sx={styles.icon}>
        <WelcomeToPharmaGapIcon />
      </Box>
      <Typography sx={[styles.title, styles.textAlign]}>{title}</Typography>
      <Typography sx={[styles.description, styles.textAlign]}>
        {description}
      </Typography>

      <Box sx={styles.buttonContainer}>
        <CustomButton
          label={strings.proceed}
          customButtonStyle={styles.proceed}
          onClick={primary}
        />
        {!isPharmacy && (
          <CustomButton
            label={strings.later}
            onClick={close}
            variant="outlined"
            customButtonStyle={styles.proceed}
          />
        )}
      </Box>
    </Box>
  );
};

export default WelcomeToPharmaGap;
